// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.monitor-analytics-panel--compact {
  gap: 0;
}

.map-cards-row {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}

.monitor-analytics-panel--compact .map-card {
  padding: 10px;
  border: 1px solid #f1f5f9;
  box-shadow: none;
}

.monitor-analytics-panel--compact .map-chart--pie {
  height: 120px;
}

.monitor-analytics-panel--compact .map-chart--bar {
  height: 120px;
}

@media (max-width: 1100px) {
  .map-cards-row {
    grid-template-columns: 1fr;
  }
}

.monitor-analytics-heading {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 4px;
}

.monitor-analytics-loading {
  font-size: 15px;
  color: #64748b;
  padding: 16px;
  text-align: center;
}

.map-card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 12px;
}

.map-card-head {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 10px;
  color: #475569;
}

.map-card-head h3 {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
}

.map-card-head p {
  margin: 2px 0 0;
  font-size: 13px;
  color: #64748b;
}

.map-chart {
  position: relative;
}

.map-chart--pie {
  height: 160px;
}

.map-chart--bar {
  height: 180px;
}

.map-pie-center {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  font-weight: 700;
  color: #0f172a;
  font-size: 18px;
}

.map-pie-center small {
  font-size: 14px;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  font-weight: 600;
}

.map-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center;
  margin-top: 8px;
  font-size: 13px;
  color: #64748b;
}

.map-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 4px;
  vertical-align: middle;
}

.map-dot--ok { background: #10b981; }
.map-dot--bad { background: #ef4444; }

.map-empty {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #94a3b8;
  font-size: 15px;
}

.map-tooltip {
  background: #fff;
  padding: 8px 10px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  font-size: 15px;
}

.map-tooltip-label {
  margin: 0 0 6px;
  font-weight: 600;
  color: #0f172a;
}

.map-tooltip-row {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #64748b;
}

.map-tooltip-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
}
`, "",{"version":3,"sources":["webpack://./src/components/MonitoringAnalyticsPanel.css"],"names":[],"mappings":"AAAA;EACE,MAAM;AACR;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,eAAe,mBAAmB,EAAE;AACpC,gBAAgB,mBAAmB,EAAE;;AAErC;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB","sourcesContent":[".monitor-analytics-panel--compact {\n  gap: 0;\n}\n\n.map-cards-row {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 10px;\n}\n\n.monitor-analytics-panel--compact .map-card {\n  padding: 10px;\n  border: 1px solid #f1f5f9;\n  box-shadow: none;\n}\n\n.monitor-analytics-panel--compact .map-chart--pie {\n  height: 120px;\n}\n\n.monitor-analytics-panel--compact .map-chart--bar {\n  height: 120px;\n}\n\n@media (max-width: 1100px) {\n  .map-cards-row {\n    grid-template-columns: 1fr;\n  }\n}\n\n.monitor-analytics-heading {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 15px;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0 0 4px;\n}\n\n.monitor-analytics-loading {\n  font-size: 15px;\n  color: #64748b;\n  padding: 16px;\n  text-align: center;\n}\n\n.map-card {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  padding: 12px;\n}\n\n.map-card-head {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  margin-bottom: 10px;\n  color: #475569;\n}\n\n.map-card-head h3 {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.map-card-head p {\n  margin: 2px 0 0;\n  font-size: 13px;\n  color: #64748b;\n}\n\n.map-chart {\n  position: relative;\n}\n\n.map-chart--pie {\n  height: 160px;\n}\n\n.map-chart--bar {\n  height: 180px;\n}\n\n.map-pie-center {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  pointer-events: none;\n  font-weight: 700;\n  color: #0f172a;\n  font-size: 18px;\n}\n\n.map-pie-center small {\n  font-size: 14px;\n  color: #64748b;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  font-weight: 600;\n}\n\n.map-legend {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  justify-content: center;\n  margin-top: 8px;\n  font-size: 13px;\n  color: #64748b;\n}\n\n.map-dot {\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  margin-right: 4px;\n  vertical-align: middle;\n}\n\n.map-dot--ok { background: #10b981; }\n.map-dot--bad { background: #ef4444; }\n\n.map-empty {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  color: #94a3b8;\n  font-size: 15px;\n}\n\n.map-tooltip {\n  background: #fff;\n  padding: 8px 10px;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n  font-size: 15px;\n}\n\n.map-tooltip-label {\n  margin: 0 0 6px;\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.map-tooltip-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  color: #64748b;\n}\n\n.map-tooltip-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
